import React from "react";
import PropTypes from "prop-types";

const SubscriptionToggle = ({ isSubscribed, onToggle, className }) => {
  return (
    <div className={`${className} subscribe-toggle flex items-center gap-3 justify-between p-1 md:p-2 md:gap-2 rounded-20 `} style={{ border: "2px solid var(--purple)" }}>
      <span className="ml-2">Subscribe And Save 10%</span>
      <label className="checkbox-style relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={isSubscribed}
          onChange={onToggle}
        />
        <div className="toggle-bg w-11 h-8 rounded-full relative transition-all">
          <div
            className={`toggle-circle absolute left-1 top-1 w-6 h-6 bg-white rounded-full transition-all ${isSubscribed ? "translate-x-6" : ""
              }`}
          />
        </div>
      </label>
    </div>
  );
};

SubscriptionToggle.propTypes = {
  isSubscribed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SubscriptionToggle;
